<template>
    <div>
        <!-- class='swiper-no-swiping' -->
        <swiper>
            <swiper-slide class='swiper-no-swiping' v-for="(item,index) in currData.imgList" :key="index">
                <div class="imgbox">
                    <div class="swiper-zoom-container">
                        <img :src="item.imgurl" alt="">
                    </div>
                </div>
                <div class="goback" @click="goback"></div>
                <div class="botomText" ref="bot" :class="isShow ? 'active' : ''">
                    <div class="botomTitle" ref="bottomTitle">
                        <div class="bottomBtn" @click="open"></div>
                        <h2 class="title">{{currData.etitle}}{{currData.title}}</h2>
                    </div>
                    <div class="bottomDetail" ref="bottomDetail">
                        <p class="attr">{{currData.quality}}</p>
                        <p class="attr">{{currData.size}}</p>
                        <p class="attr">{{currData.donor}}</p>
                        <div class="botomDetail">{{currData.text}}</div>
                    </div>
                </div>

            </swiper-slide>
        </swiper>
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
    </div>
</template>

<script type="text/javascript">
    import Swiper from 'swiper';
    import 'swiper/dist/css/swiper.min.css';
    import { swiper, swiperSlide } from 'vue-awesome-swiper';
    export default {
        methods:{
            open (){
                this.isShow = !this.isShow
            },
            goback(){
                if(window.history.length == 1){
                    this.$router.push({path:"/"})
                }else{
                    this.$router.go(-1)
                }
            }
        },
        data(){
            return{
                currData:'',
                isShow :false,
                allData:[{
                    id:'unit1_01',
                    imgList:[{
                        imgurl:require('../static/imgs/proList1/big/proList1_01.jpg')
                    }],
                    title:' 草书五言诗轴',
                    etitle:'赵鹤（清）',
                    size:'纵154厘米，横38厘米',
                    donor:'常赞春先生捐赠',
                    quality:'绢本',
                    text:'赵鹤，生卒年不详，字鸣皋，号白山，山西榆次人，诸生。性格孤高，嗜金石文字，善草书。在绘画方面，主要从事人物和兰竹的创作，其画风亦以行草书法参之。据说他每日挥毫不倦，直至耄年犹作书不辍，可惜流传不多。释文：西郊有别业，清兴与云齐。石骨得诗瘦，阴相逐月夜。野塘通古涧，细雨入新题。老马知余意，随身似杖藜。白山赵鹤。钤印：赵鹤之印（ 白）、鸣皋（朱）、芏砚堂（朱）、霁山鉴定（白）。'
                },{
                    id:'unit1_02',
                    imgList:[
                        {imgurl:require('../static/imgs/proList1/big/proList1_02.jpg')}
                    ],
                    title:' 行书王昌龄《芙蓉楼送辛渐》诗轴',
                    etitle:'孙嘉淦（清）',
                    size:'纵175厘米，横77.5 厘米',
                    donor:'常赞春先生捐赠',
                    quality:'纸本',
                    text:'孙嘉淦（1683—1753），字锡公，又字懿斋，号静轩，山西兴县人。康熙五十二年（1713）进士，历康熙、雍正、乾隆三朝，是清前期一位政声显赫的官员。其书法如若其人，超然挺拔，不入俗流。释文：寒雨连江夜入吴，平明送客楚山孤。洛阳亲友如相问，一片冰心在玉壶。书为元翁老年学兄，合河孙嘉淦。钤印：太子少保（白）、孙嘉淦字锡公之章（白）、和本天地之精（白）。'
                },{
                    id:'unit1_03',
                    imgList:[
                        {imgurl:require('../static/imgs/proList1/big/proList1_03.jpg')}
                    ],
                    title:' 行书元好问《换得云台帖，喜而赋诗》诗轴',
                    etitle:'孙嘉淦（清）',
                    size:'纵94.5厘米，横54 厘米',
                    donor:'常赞春先生捐赠',
                    quality:'纸本',
                    text:'释文：周官武臣奉朝请，剑佩束缚非天真。世间曾有华佗帖，神物已化延平津。米狂雄笔照万古，北宗草书才九人。今日云台见遗墨，黄金牢锁玉麒麟。懿翁孙嘉淦。 钤印：孙嘉淦（朱）。'
                },{
                    id:'unit1_05',
                    imgList:[
                        {imgurl:require('../static/imgs/proList1/big/proList1_05.jpg')}
                    ],
                    title:' 行书苏轼《跋石钟山记后》轴',
                    etitle:'祁世长（清）',
                    size:'纵118厘米，横49厘米',
                    donor:'常赞春先生捐赠',
                    quality:'纸本',
                    text:'祁世长（1825—1892），字子禾、念慈，一字子和，号敏斋，山西寿阳人，祁寯藻之子。历官内阁学士、监察院左都御史、工部尚书、顺天府尹等职。著有《思复堂集》《祁文瑞公年谱》等。其深濡家学，书法得乃父精髓，雅致端庄，中和位育，堪称一绝，继承和光大了祁氏一门的深厚传统和文化。释文：钱唐东南皆有水乐洞，泉流空岩中，皆自然宫商。又自灵隐下天竺，而上至上天竺，溪行两山间，巨石磊磊如牛羊，其声空砻然，真若钟声，乃知庄生所谓天籁也。祁世长。钤印：祁世长印（白）、子禾（朱）。'
                },{
                    id:'unit1_06',
                    imgList:[
                        {imgurl:require('../static/imgs/proList1/big/proList1_06.jpg')}
                    ],
                    title:' 行书录《纯正蒙求》句轴',
                    etitle:'祁世长（清）',
                    size:'纵117厘米，横48厘米',
                    donor:'常赞春先生捐赠',
                    quality:'纸本',
                    text:'释文：北魏崔孝芬、孝伟兄弟，孝义慈厚，一钱尺布不入私房，吉凶有需，聚对分给。诸妇亦相亲爱，有无共之。祁世长。钤印：祁世长印（白）、子禾（朱）。'
                },{
                    id:'unit1_07',
                    imgList:[
                        {imgurl: require('../static/imgs/proList1/big/proList1_07.jpg')}
                    ],
                    title:' 《贾景伯嗜学图》轴',
                    etitle:'钱慧安（清）',
                    size:'纵109厘米，横49.5厘米',
                    donor:'常赞春先生捐赠',
                    quality:'纸本，设色',
                    text:'钱慧安（1833—1911），又名贵昌，字吉生，号清溪樵子。今上海浦东。工画仕女人物，初学费丹旭，画仕女清秀多姿。花卉、山水，自出新意。光绪、宣统间卖画上海，名重一时。曾任上海豫园书画会会长。有《清溪画谱》。图绘历史典故贾景伯隔篱听学，用笔细腻，设色淡雅。行书题：“乙酉天贶日仿华秋岳笔，清溪樵子钱慧安。”钤白文印“吉生”。'
                },{
                    id:'unit1_08',
                    imgList:[
                        {imgurl:require('../static/imgs/proList1/big/proList1_08.jpg')}
                    ],
                    title:' 仿华喦《忘忧多子图》轴',
                    etitle:'温忠翰（清）',
                    size:'纵76.5厘米，横38.2厘米',
                    donor:'常赞春先生捐赠',
                    quality:'纸本，设色',
                    text:'温忠翰，生卒年不详。字味秋，山西太谷人。同治元年（1862）中进士第三名（探花）。曾任翰林院编修、湖南学政，历任四川副考官司、湖南学政等职。善抚琴，能诗文，工书法，惜墨迹流传无多，所传尤其宝贵。萱草忘忧，石榴多子，两者争艳，绮丽多姿。画题“忘忧多子图，丙寅仲春仿新罗山人本，味秋温忠翰。”钤白文方印“温忠翰”、朱文方印“味秋”。'
                },{
                    id:'unit1_09',
                    imgList:[
                        {imgurl:require('../static/imgs/proList1/big/proList1_09.jpg')}
                    ],
                    title:' 山水轴',
                    etitle:'白恩佑（清）',
                    size:'纵47厘米，横31.5厘米',
                    donor:'常赞春先生捐赠',
                    quality:'纸本，墨笔',
                    text:'白恩佑（1808—1880），字启南、兰岩，号蔼人、石仙等，山西介休人。道光二十七年（1847）翰林。历官礼部郎中，会考御史、江南道监察御史。工书画。山水、花卉，不袭故常。著有《进修堂诗集》《进修堂古文学制》等。图仿元黄公望笔法，作墨笔山水，山秀林密，小舟泛行。行书题“仿子久笔法，乙丑六月挥汗为梦渔前辈同年大人雅粲，侍白恩佑。”钤朱文印“石仙”。'
                },{
                    id:'unit2_01',
                    imgList:[
                        {imgurl:require('../static/imgs/proList2/big/proList2_01.jpg')}
                    ],
                    title:' 行书七言联',
                    etitle:'张之万（清）',
                    size:'纵132厘米，横31.2厘米',
                    donor:'马鑫先生捐赠',
                    quality:'纸本',
                    text:'张之万（1811—1897），字子青，河北沧州人。道光二十七年(1847) 状元及第，曾任河南巡抚、闽浙总督等，官至东阁大学士。工书画，画擅山水，骨秀神清，为士大夫画中逸品。书精小楷，唐法晋韵，兼擅其胜。释文：文房益友木司直，香国都知金辟邪。星躔先生雅正，张之万。钤印：张之万印（白）、子青（朱）'
                },{
                    id:'unit2_02',
                    imgList:[
                        {imgurl:require('../static/imgs/proList2/big/proList2_02.jpg')}
                    ],
                    title:' 《紫藤蜜蜂图》轴',
                    etitle:'齐白石（现代）',
                    size:'纵97厘米，横39.5厘米',
                    donor:'尹正斋先生捐赠',
                    quality:'纸本，设色',
                    text:'齐白石（1864—1957），原名纯芝，字渭清，号兰亭，后改名璜，字濒生，号白石，湖南湘潭人。早年学木工，1888年走上专业绘画道路，1919年在北京定居，以篆刻和绘画为生。60岁后，渐将传统写意画与民间绘画的表现手法融为一体，形成了自己独特的艺术风格。擅长花鸟虫鱼，亦作山水人物，篆刻初学浙派，后多取法汉代凿印。此画作于1928年。藤蔓盘曲交错，蜜蜂闻香而来，静中有动，率真之趣跃然纸上。款“锡卿先生请属，戊辰秋九月齐璜制”。后再署款“寄萍堂上老人”。钤“白石翁”“木人”两方印。'
                },{
                    id:'unit2_03',
                    imgList:[
                        {imgurl:require('../static/imgs/proList2/big/proList2_03.jpg')}
                    ],
                    title:'行书七言诗轴',
                    etitle:'朱雯（清）',
                    size:'纵207厘米，横49.3厘米',
                    donor:'马鑫先生捐赠',
                    quality:'绫本',
                    text:'朱雯，生平不详，清代浙江人。释文：凫飞海国起讴歌，蒙峄南阳我屡过。花满讼庭翔独鹤，琴张卧客笼群鹅。三年挥尘聆珠咳，十月孤帆下濁河。枫冷霜黄无限意，遥看云潇转鼋鼍。里言奉别冲翁老年台兼求郢政，浙西朱雯具稿。钤印：朱雯之印（白）、复斋（朱）、矞三氏（白）。'
                },{
                    id:'unit2_04',
                    imgList:[
                        {imgurl:require('../static/imgs/proList2/big/proList2_04.jpg')}
                    ],
                    title:'《接蝠图》轴',
                    etitle:'黄慎（清）',
                    size:'纵192厘米，横109厘米',
                    donor:'1953年尹正斋先生捐赠',
                    quality:'纸本，设色',
                    text:'黄慎（1687—1770后），字恭寿、恭懋、躬懋，号瘿瓢子，别号东海布衣，福建宁化人。擅画人物、花卉、蔬果，笔姿放纵，风格豪放，亦工诗、书。“扬州八怪”之一。著有《蛟湖诗钞》。绘一老者双手接蝠，用笔粗放，水墨交融，衣纹线条时有飞白，人物形神俱佳，是其草书入画的代表作之一。题款“哑性多累，聋性多喜。与其缄口，不如充耳。宁化瘿瓢子慎写”。钤“黄慎”“瘿瓢山人”“东海布衣”印。'
                },{
                    id:'unit2_05',
                    imgList:[
                        {imgurl:require('../static/imgs/proList2/big/proList2_05.jpg')}
                    ],
                    title:'《云峰霖雨图》轴',
                    etitle:'高凤翰（清）',
                    size:'纵125厘米，横46厘米',
                    donor:'1954年吴元善先生捐赠',
                    quality:'绢本，设色',
                    text:'高凤翰（1683—1749），字西园，号南邨、南阜山人，山东胶州人。晚年因病风痹，用左手作书画，自号尚左生。五十五岁刻印“丁巳残人”。工书画篆刻，擅画花卉、山水，不拘法度。构图饱满，皴笔不多，以涂染的方式描绘云峰、山石、树木，别有特色。此图绘于乾隆丁卯年（1747），是高凤翰晚年的作品。'
                },{
                    id:'unit2_06',
                    imgList:[
                        {imgurl:require('../static/imgs/proList2/big/proList2_06.jpg')}
                    ],
                    title:'《子夜歌图》轴',
                    etitle:'改琦（清）',
                    size:'纵118厘米，横39.5厘米',
                    donor:'1954年吴元善先生捐赠',
                    quality:'绢本，设色',
                    text:'改琦（1773—1828），字伯韫，号香白、七芗，别号玉壶山人等，上海松江人。工诗词，以擅画人物、肖像、佛像闻名，亦工山水、花卉。写仕女则称妙一时，形象纤细俊秀，用笔轻柔流畅，创造了仕女画的新风貌。著有《玉壶山房词选》。此图落墨洁净，敷色清雅，仕女娟秀清癯，怀抱长箫，用笔精细，刻画传神，是改琦人物画精品之一。题《子夜歌》：“旧时月色凉于雪，满衫花影飞仙蝶。碧玉一枝箫，红阑十四桥。烟丝吹不断，翠里风零乱。枨触竹西亭，销魂是此声。”款“七芗”，钤“改琦之印”。'
                },{
                    id:'unit2_07',
                    imgList:[
                        {imgurl:require('../static/imgs/proList2/big/proList2_07.jpg')}
                    ],
                    title:'仿元人山水册',
                    etitle:'赫奕（清）',
                    size:'纵47.5厘米，横33厘米',
                    donor:'1956年张会斗先生捐赠',
                    quality:'纸本，设色',
                    text:'赫奕，生卒年不详，一作颐，字澹士，号南谷，别号碧岩箫史、碧箫外史，满洲人。擅画，山水宗法元人，笔意苍劲。八开。仿元人山水，笔精墨妙，咫尺之间，有千里之趣。款“赫奕”，钤有“赫奕之印”“澹士”“赫奕”“中林士”印。画对页为榆次常旭春行书杜甫《秋兴八首》。'
                },{
                    id:'unit2_08',
                    imgList:[
                        {imgurl:require('../static/imgs/proList2/big/proList2_08_01.jpg')},
                        {imgurl:require('../static/imgs/proList2/big/proList2_08_02.jpg')},
                    ],
                    title:'《兰竹图》册',
                    etitle:'钱载（清）',
                    size:'纵23厘米，横26.6厘米',
                    donor:'1956年张会斗先生捐赠',
                    quality:'纸本，墨笔',
                    text:'钱载(1708—1793)，字坤一，号箨石，又号匏尊，晚号万松居士等，秀水(今浙江嘉兴)人。乾隆十七年(1752)进士，官至礼部侍郎。精书画，善水墨，尤工兰竹。工诗文，为乾嘉年间秀水诗派的代表人物，著有《石斋诗文集》。十开，墨笔绘竹、兰、石，笔法多变，墨色秀润。末开款：“乾隆壬寅初秋仿天池先生笔意，应慕堂先生鉴，箨石弟钱载。”钤“坤一”“钱氏载印”“七十二泉生”三方印。'
                },{
                    id:'unit2_09',
                    imgList:[
                        {imgurl:require('../static/imgs/proList2/big/proList2_09.jpg')}
                    ],
                    title:'《丛林流水图》轴',
                    etitle:'程淓（清）',
                    size:'纵133厘米，横71厘米',
                    donor:'1956年张会斗先生捐赠',
                    quality:'绢本，墨笔',
                    text:'程淓，生卒年不详，字箕山，号岸舫，广信（今江西上饶）人，后入籍顺天（今北京）。顺治六年（1649）进士，官江西广信知府。擅画山水。昔张颠以发濡墨作书，今画家效此意作画，笔墨自有新意。款“时戊戌冬仲念日，箕山程淓画并题”。钤“箕山”“程淓私印”两方印。“戊戌”为清康熙五十七年（1718）。'
                },{
                    id:'unit2_10',
                    imgList:[
                        {imgurl:require('../static/imgs/proList2/big/proList2_10.jpg')}
                    ],
                    title:'《雪景山水》横幅',
                    etitle:'戴克昌（清）',
                    size:'纵116厘米，横237厘米',
                    donor:'1958年贾玉祥先生捐赠',
                    quality:'纸本，设色',
                    text:'戴克昌，生卒年不详，字丑石，河北昌黎人。善画山水，尤工墨龙，其山水以淡着色者为佳，简练明洁，脱去尘俗。画家以“留白”加渲染的方式表现雪景，山脚茅屋中一老者倚窗远眺，有访客缓缓而来。右侧行书“同治丁卯年处暑后五日，丑石戴克昌写。”钤白文印“丑石戴克昌印”。'
                },{
                    id:'unit2_11',
                    imgList:[
                        {imgurl:require('../static/imgs/proList2/big/proList2_11.jpg')}
                    ],
                    title:'《麻姑献寿图》轴',
                    etitle:'焦秉贞（清）',
                    size:'纵148.5厘米，横76.3厘米',
                    donor:'1960年刘画南先生捐赠',
                    quality:'纸本，设色',
                    text:'焦秉贞，生卒年不详，字尔正，山东济宁人。康熙年间供奉内廷，官钦天监五官正。善画人物、山水、花卉、楼台。曾画《耕织图》四十六幅,为其代表作。图以“麻姑献寿”为题材，描写精细，人物逼真，参用西法，甚为精妙。画心左侧楷书款：“臣焦秉贞恭画。”钤“臣秉贞”“恭绘”两方印。'
                },{
                    id:'unit2_12',
                    imgList:[
                        {imgurl:require('../static/imgs/proList2/big/proList2_12.jpg')}
                    ],
                    title:'《僧王像》轴',
                    etitle:'无款（清）',
                    size:'纵170厘米，横83厘米',
                    donor:'1960年刘画南先生捐赠',
                    quality:'纸本，设色',
                    text:'图中人物身着官服，庄重威严，形象逼真，生动传神。诗堂有宣统元年（1909）刘春霖行书“皇清僧王之像”及题记。'
                },{
                    id:'unit2_13',
                    imgList:[
                        {imgurl:require('../static/imgs/proList2/big/proList2_13.jpg')}
                    ],
                    title:'《岁寒三友图》轴',
                    etitle:'王岱（清）',
                    size:'纵112厘米，横38厘米',
                    donor:'1960年梁寯先生捐赠',
                    quality:'纸本，墨笔',
                    text:'王岱，生卒年不详，字山长，号了庵，别号石史，湖南湘潭人。明崇祯十二年（1639）举人，能诗文，工书画，山水奇逸，兼擅人物花鸟，深得古人笔意。著有《且园集》等。松竹梅三友是文人画家喜爱的题材，借物抒情。此图是画家为挚友戴廷栻所画。款“潭州同学弟石史王岱识于燕山邸次”。钤“王岱私印”“石史”“且园”三方印。'
                },{
                    id:'unit2_14',
                    imgList:[
                        {imgurl:require('../static/imgs/proList2/big/proList2_14.jpg')}
                    ],
                    title:'《太华冲雪图》卷',
                    etitle:'秦炳文（清）',
                    size:'纵33厘米，横69厘米',
                    donor:'1961年董寿平先生捐赠',
                    quality:'纸本，设色',
                    text:'秦炳文（1803—1873），字砚云，号谊亭、古华山樵等，江苏无锡人。道光二十年（1840）举人，官户部主事。工诗擅画，精鉴赏，尤擅山水。画家“借地为白”表现雪景，天空淡墨涂染，披麻皴描绘山石，树木皴点精致。题款“太华冲雪图，壬申仲春写奉研樵仁兄大人雅正，秦炳文”。钤“古华山樵”印。卷尾有周寿昌、李慈铭、陈乔森、张之洞、谢维藩、潘祖荫等题记，具有丰富的史料价值。曾由洪洞董氏家藏，钤“董揆鉴藏”“洪洞董氏家藏”印。'
                },{
                    id:'unit2_15',
                    imgList:[
                        {imgurl:require('../static/imgs/proList2/big/proList2_15.jpg')}
                    ],
                    title:'《汉书下酒图》卷',
                    etitle:'董文涣（清）',
                    size:'纵28.7厘米，横57.5厘米',
                    donor:'1961年董寿平先生捐赠',
                    quality:'纸本，设色',
                    text:'董文涣（1833—1877），字尧章，号砚樵，山西洪洞人。清咸、同年间著名诗人、诗律学家。曾任顺天乡试、会试同考官。著述颇丰，有《砚樵山房诗集》《砚樵山房文集》《集韵编雅》《砚樵山房日记》等。精于书法、鉴赏。以宋代苏舜钦读《汉书》佐酒的故事为题入画。行书题“借酒消块磊，块磊多余酒。所以书下之，两汉不去手。读过千百遍，饮可五六斗。掩卷卧北窗，沈醉夫何有？光绪元年初夏，戏题汉书下酒图。研秋董文涣。”钤“研樵诗草”“董揆鉴藏”两方印。'
                },{
                    id:'unit2_16',
                    imgList:[
                        {imgurl:require('../static/imgs/proList2/big/proList2_16.jpg')}
                    ],
                    title:'《老屋校书图》卷',
                    etitle:'温忠翰（清）',
                    size:'纵32厘米，横129厘米',
                    donor:'1961年董寿平先生捐赠',
                    quality:'纸本，设色',
                    text:'此图为温忠翰为董文涣而作。用笔率意，构图自然，描述董文涣在书斋枌东老屋校书的场景。温忠翰楷书题“枌东老屋校书图”，“榆西曾谒诗人宅，今日枌东更绘图。老屋百年书万卷，下帷重见董江都”。款“壬申春初拟文待诏笔应，研侨年老前辈雅教，年侍温忠翰写”。后钤“忠翰印信”“凤翼山樵”两方印。画心及卷尾有李慈铭、陈乔森等多人题诗。'
                },{
                    id:'unit2_17',
                    imgList:[
                        {imgurl:require('../static/imgs/proList2/big/proList2_17.jpg')}
                    ],
                    title:'《松石图》轴',
                    etitle:'汪洛年（民国）',
                    size:'纵76.2厘米，横29.5厘米',
                    donor:'1961年常风玄先生捐赠',
                    quality:'纸本，墨笔',
                    text:'汪洛年（1870—1925），字社耆，号友箕、鸥客，钱塘(今杭州)人。工山水，戴以恒弟子，后学“四王”，澹雅超逸。书画、篆刻皆守师法，气韵清逸。曾被张之洞聘为两湖师范学校图画教员，闻名一时。辛亥革命后寓沪，卖画以自给。图中巨石巍然挺立，苍松傲居于上，两者相偎相依。款“乙卯十一月杭州汪洛年写”，钤白文印“汪洛年”、朱文印“伊斋”。'
                },{
                    id:'unit2_18',
                    imgList:[
                        {imgurl:require('../static/imgs/proList2/big/proList2_18.jpg')}
                    ],
                    title:'临王羲之《明府帖》轴',
                    etitle:'傅山（清）',
                    size:'纵76.5厘米，横38.2厘米',
                    donor:'1963年傅作义先生捐赠',
                    quality:'绢本',
                    text:'傅山（1607—1684），初名鼎臣，字青竹，后改名山，字青主，号真山、青羊庵主、朱衣道人等，阳曲（今山西太原）人。清初著名学者、思想家、医学家、文学家、书画家。公书擅画，真、草、篆、隶无不精通，尤以草书成就最高。所著颇多，可惜大都散佚，流传主要有《霜红龛集》《两汉书姓名韵》《傅青主女科》等。释文：前从洛至此，未及彼参承。愿夫子勿悒悒矣。当日缘明府共饮，遂阙问，愿足下莫见责。羲之顿首。真山临。 钤印：傅山之印（白）。'
                },{
                    id:'unit2_19',
                    imgList:[
                        {imgurl:require('../static/imgs/proList2/big/proList2_19.jpg')}
                    ],
                    title:'行书五绝诗轴',
                    etitle:'陈继儒（明）',
                    size:'纵78.5厘米，横18厘米',
                    donor:'1964年罗静宜女士捐赠',
                    quality:'绫本',
                    text:'陈继儒（1558—1639），字仲醇，号眉公、糜公，华亭（今上海松江）人。工诗文，擅书画，精鉴赏。书法在苏轼、米芾之间，萧散秀雅。释文：科头读道书，修竹是吾庐。水白花香夜，临流学钓鱼。陈继儒。钤印：糜公（白）、陈继儒印（朱）、陈氏之章（白）、迸青珍藏（白）。'
                },{
                    id:'unit2_20',
                    imgList:[
                        {imgurl:require('../static/imgs/proList2/big/proList2_20.jpg')}
                    ],
                    title:'草书《游房山山寺》诗轴',
                    etitle:'王铎（清）',
                    size:'纵236厘米，横53厘米',
                    donor:'1964年罗静宜女士捐赠',
                    quality:'绫本',
                    text:'王铎（1592—1652），字觉斯，号嵩樵、烟潭渔叟等，河南孟津人。明天启二年（1622）进士，入清官至大学士，擢礼部尚书。工诗文，擅书画。书法擅行草，劲健洒脱，淋漓痛快。释文：怅望寻山径，云栖第几峰。初来不辨路，何自有清钟。耕向石中伍，身忘尘外踪。光香曲处得，还听响淙淙。游房山山寺，抱老公祖正，辛巳夜，王铎。钤印：王铎之印（白）。'
                },{
                    id:'unit2_21',
                    imgList:[
                        {imgurl:require('../static/imgs/proList2/big/proList2_21.jpg')}
                    ],
                    title:'草书杜甫《夔州歌》之四诗轴',
                    etitle:'傅山（清）',
                    size:'纵185厘米，横56厘米',
                    donor:'1964年罗静宜女士捐赠',
                    quality:'绫本',
                    text:'释文：白盐赤甲俱刺天，闾阎缭绕接山巅，枫林橘树丹青合，复道重楼锦绣悬。傅山书。钤印：傅山印（白）。'
                },{
                    id:'unit2_22',
                    imgList:[
                        {imgurl:require('../static/imgs/proList2/big/proList2_22.jpg')}
                    ],
                    title:' 行书王昌龄《芙蓉楼送辛渐》诗轴',
                    etitle:'孙嘉淦（清）',
                    size:'纵175厘米，横77.5 厘米',
                    donor:'马鑫先生捐赠',
                    quality:'绫本',
                    text:'释文：圣慈允许守宫，稍减罪责，犹深忧惧。续冀面言，不一一。诚悬呈。傅山临。钤印：傅山印（白）。'
                },{
                    id:'unit2_23',
                    imgList:[
                        {imgurl:require('../static/imgs/proList2/big/proList2_23.jpg')}
                    ],
                    title:'篆书《孟子·滕文公下》句轴',
                    etitle:'王澍（清）',
                    size:'纵109厘米，横58厘米',
                    donor:'1964年罗静宜女士捐赠',
                    quality:'纸本',
                    text:'王澍（1668—1743），字若林，号虚舟、恭寿、水精宫道人等，金坛（今江苏常州）人。精鉴古，工篆刻，擅书法。书法师欧阳询、褚遂良。尤精篆书，法李斯，称一时好手。释文：居天下之广居，立天下之正位，行天下之大道。得志，与民由之；不得志，独行其道。富贵不能淫，贫贱不能移，威武不能屈，此之谓大丈夫。癸丑三月二十四日书，琅琊王澍。钤印：王澍印（白）、恭寿（朱）、聊以自娱乐（白）、頵鉴藏书画印（白）。'
                },{
                    id:'unit2_24',
                    imgList:[
                        {imgurl:require('../static/imgs/proList2/big/proList2_24.jpg')}
                    ],
                    title:'行书录《内史与谢尚书书》轴',
                    etitle:'包世臣（清）',
                    size:'纵128厘米，横55.5厘米',
                    donor:'1964年罗静宜女士捐赠',
                    quality:'纸本',
                    text:'包世臣(1775—1855)，字诚伯，号慎伯、倦翁、小倦游阁外史，安徽泾县人。精研金石，肆力北碑，著有《艺舟双楫》和《安吴论书》。释文：江左之地，平日，扬州一良刺史便足统之，况以群才而更不理，正由为法不一，牵制者众。思简而易从，便足以保守成业矣。督监耗盗官米，常以万计，吾谓诛翦一人，其后便断，而时命不同。近检校诸县，无不皆尔。余姚近十万斛，重敛以资奸吏，令国用空乏，良可叹也。月波三兄雅鉴，咸丰壬子冬十月既望，江东布衣包世臣录内史与谢尚书书。钤印：世臣私印（白）、包氏慎伯（朱）、白门倦游阁外史章（朱）。'
                },{
                    id:'unit2_25',
                    imgList:[
                        {imgurl:require('../static/imgs/proList2/big/proList2_25.jpg')}
                    ],
                    title:'《山水图》轴',
                    etitle:'严载（清）',
                    size:'纵96厘米，横39.5厘米',
                    donor:'1964年罗静宜女士捐赠',
                    quality:'纸本，墨笔',
                    text:'严载，生卒年不详，字沧醅，华阳（今四川成都）人。擅画山水，兼擅花鸟。深远法构图，笔墨苍润，意境空灵。钤“严载之印”“字沧醅”两方印。'
                },{
                    id:'unit2_26',
                    imgList:[
                        {imgurl:require('../static/imgs/proList2/big/proList2_26.jpg')}
                    ],
                    title:'行书五言诗轴',
                    etitle:'吴雯（清）',
                    size:'纵79厘米，横28厘米',
                    donor:'1975年王世庆先生捐献',
                    quality:'纸本',
                    text:'吴雯（1644—1704），字天章，号莲洋，又号玉溪生，山西永济人。清初著名诗人，诗才高妙，在当时被文坛领袖王士禛誉为“仙才”，著有《莲洋集》。亦工于书法，颇得王献之神髓，其书法骨力独具，傲岸不屈，既有文人的飘逸，又有落拓江湖的洒脱，在清代就常被人奉为法书。释文：风廊经积雨，一半莓苔斑。晓起喜无营，爱兹池上山。笔墨有余清，吟啸颇亦闲。君家辉棣蕚，皆为玉笋班。天伦良可乐，客子舒心颜。登楼托遥情，佳气通函关。昨日太华来，仙灵砭我顽。正欲习静默，适卧花林间。少日且归去，开门俯潺湲。玉溪吴雯。钤印：吴雯之印（白）、天章（白）、王孟昭所收藏（朱）、郇阳王氏图书（白）、孟昭珍藏（白）。'
                },{
                    id:'unit2_27',
                    imgList:[
                        {imgurl:require('../static/imgs/proList2/big/proList2_27_01.jpg')},
                        {imgurl:require('../static/imgs/proList2/big/proList2_27_02.jpg')},
                        {imgurl:require('../static/imgs/proList2/big/proList2_27_03.jpg')},
                        {imgurl:require('../static/imgs/proList2/big/proList2_27_04.jpg')},
                        {imgurl:require('../static/imgs/proList2/big/proList2_27_05.jpg')},
                        {imgurl:require('../static/imgs/proList2/big/proList2_27_06.jpg')},
                        {imgurl:require('../static/imgs/proList2/big/proList2_27_07.jpg')},
                        {imgurl:require('../static/imgs/proList2/big/proList2_27_08.jpg')},
                        {imgurl:require('../static/imgs/proList2/big/proList2_27_09.jpg')},
                        {imgurl:require('../static/imgs/proList2/big/proList2_27_10.jpg')},
                        {imgurl:require('../static/imgs/proList2/big/proList2_27_11.jpg')},
                        {imgurl:require('../static/imgs/proList2/big/proList2_27_12.jpg')},
                        {imgurl:require('../static/imgs/proList2/big/proList2_27_13.jpg')},
                        {imgurl:require('../static/imgs/proList2/big/proList2_27_14.jpg')},
                        {imgurl:require('../static/imgs/proList2/big/proList2_27_15.jpg')},
                        {imgurl:require('../static/imgs/proList2/big/proList2_27_16.jpg')},
                    ],
                    title:'行书诗册',
                    etitle:'祁寯藻（清）',
                    size:'纵26厘米，横21.5厘米',
                    donor:'1975年王世庆先生捐献',
                    quality:'纸本',
                    text:'行书元结《春陵行》及杜甫《同元使君春陵行》两篇，书法出颜鲁公而另有新意，意到笔随，出神入化。款“咸丰七年岁次丁巳六月廿又六日，读杜诗至和元使君春陵行并元两篇，慨然三叹，挥汗录之，息翁时年六十有五。”册尾有张籁、贾景德等人题跋。钤印：祁寯藻印（朱）、二十二通籍三十八省亲归里四十陈情乞养六十二致仕（朱）、息翁（白）、孟昭珍藏（白）。'
                },{
                    id:'unit2_28',
                    imgList:[
                        {imgurl:require('../static/imgs/proList2/big/proList2_28.jpg')}
                    ],
                    title:'扇画合轴',
                    etitle:'宋葆淳等（清）',
                    size:'纵52厘米，横158厘米',
                    donor:'郝秉寯先生捐赠',
                    quality:'纸/绢本',
                    text:'（1） 宋葆淳（1748—1825），字帅初，号芝山，晚号倦陬，安邑（今山西运城市）人。乾隆四十八年（1783）举人，官至隰州学正。工书善画，精于金石考据。山水得宋人笔意，苍秀嫣润。释文：天际乌云含雨重，楼前红日照山明。嵩阳居士今何在，青眼看人万里情。此蔡君谟梦中诗也。仆在钱唐，一日谒陈述（古），邀余饮小阁中。壁上小诗一绝，君谟真迹也。良玉五兄先生政，葆淳。钤印：宋葆淳印（白）、帅初（朱）。（2）沈陛（生卒年不详），字左臣，号小休，清浙江杭州人。善画墨竹，或于一幅中合画兰竹，引人入胜。释文：玉墀沈陛写。钤印：陛左臣印（朱）、囗囗珍藏（朱）。（3）汪敦元，生平不详，江苏人，清光绪年间曾任山西灵石县令。释文：功战日作，流血于野。自泰古始，世无万数，陀及五帝，莫能禁止。乃今壹家。己亥仲夏节临《峄山碑》，书于桐封客次，汪敦元。钤印：敦（白）、元（朱）。'
                },{
                    id:'unit2_29',
                    imgList:[
                        {imgurl:require('../static/imgs/proList2/big/proList2_29.jpg')}
                    ],
                    title:'《芙蓉水鸟图》轴',
                    etitle:'张敔（清）',
                    size:'纵179.5厘米，横45厘米',
                    donor:'朱绍钦先生捐赠',
                    quality:'纸本',
                    text:'张敔（1734—1803），字茝园，又字芷园，号雪鸿、南泉山人等，安徽桐城人，迁江苏江宁。乾隆二十七年（1762）举人，官湖北房县知县。善画山水、人物、花卉、禽虫，书法擅四体及飞白书，能以左手、指头及竹筷作书画。图绘秋天景致，江边芙蓉已老，两只水鸟戏于水上。行书题“秋水芙蓉老，秋林霜叶红。双凫溪上宿，闲意写秋风。南泉山人张敔。”钤白文印“雪鸿”。'
                },{
                    id:'unit2_30',
                    imgList:[
                        {imgurl:require('../static/imgs/proList2/big/proList2_30_1.jpg')},
                        {imgurl:require('../static/imgs/proList2/big/proList2_30_2.jpg')},
                    ],
                    title:'《杨二酉父母之诰命》卷',
                    etitle:'杨二酉（清）',
                    size:'纵30厘米，横181厘米',
                    donor:'游介忱先生捐赠',
                    quality:'绫本',
                    text:'杨二酉（1705—1780），字学山，号又村，别号西园、一梅居士，晚年号悔翁，太原晋祠人。乾隆年间著名官吏、书法家，曾任编修等文职。在乡间研究与保护晋祠，颇有成果。著有《柳南诗钞》。他是清代山西又一书法大家。其书法作品意境高迈，天趣流动，以颜真卿笔法为基调，参以二王笔意，深沉中极备灵动之致，凝练雄浑，意态雍容，具见其非凡的功力。释文：奉天承运皇帝制曰：宣猷服采，中朝抒报最之忱；锡类推恩，休命示酬庸之典。尔杨廷璿，乃翰林院编修杨二酉之父。令德践修，义方夙著。诗书启后，用彰式谷之风；弓冶传家，克作教忠之则。兹以覃恩，封尔为文林郎，翰林院编修，锡之敕命。於戏！笃生杞梓之材，功归庭训；丕焕丝纶之色，荣播天章。制曰：壸教凝祥，懋喜猷于朝宁；国常布惠，杨休命于庭闱。尔翰林院编修杨二酉之母李氏，勤慎宜家，贤明训后，相夫以顺，含内美于珩璜；鞠子有成，树良材于桢干。兹以覃恩，赠尔为孺人。於戏！昭兹令善之声，荣施勿替；食尔劬劳之报，遗范长垂。乾隆二年三月初六日。钤印：敕命之宝（朱）。'
                },{
                    id:'unit3_01',
                    imgList:[
                        {imgurl:require('../static/imgs/proList3/big/proList3_01.jpg')}
                    ],
                    title:'《风竹图》轴',
                    etitle:'顾安（元）',
                    size:'纵106厘米，横33.5厘米',
                    donor:'1986年钱自在先生捐赠',
                    quality:'纸本，墨笔',
                    text:'顾安（1289-约1365年），字定之，号迂讷居士，江苏苏州人。工写行草，擅画墨竹，尤喜画风竹新篁。以书法用笔绘风竹，墨色浓淡虚实互衬，既写出竹叶在风中飘飞，亦增强了画面层次感。款“迂讷老人顾定之为止善写于绿波轩”，钤“顾定之印”“迂讷老人”两方印。画上有张绅、俞贞木、周博等九人题诗。'
                },{
                    id:'unit3_02',
                    imgList:[
                        {imgurl:require('../static/imgs/proList3/big/proList3_02.jpg')}
                    ],
                    title:'《起蛟图》轴',
                    etitle:'无款（元）',
                    size:'纵95.5厘米，横40.5厘米',
                    donor:'1986年钱自在先生捐赠',
                    quality:'绢本，设色',
                    text:'图中树木飘摇，风急云涌，蛟龙欲出，画家以浓淡不同的笔墨描绘出山雨欲来之景，极富感染力。此图曾经元内府与清代卞永誉收藏，钤有“宣文阁印”“式古堂书画印”。诗堂有清末李寄云、徐宗浩、溥伒题记。'
                },{
                    id:'unit3_03',
                    imgList:[
                        {imgurl:require('../static/imgs/proList3/big/proList3_03.jpg')}
                    ],
                    title:'《祇园大会图》卷',
                    etitle:'髪僧（元）',
                    size:'纵37.2厘米，横1889厘米',
                    donor:'1986年钱自在先生捐献',
                    quality:'瓷青纸，描金',
                    text:'髪僧，生卒年不详，日本僧人，元末明初寄寓江浙，善画佛像，为一时士大夫所重。祇园，全称“祇树给孤独园”或“祇园精舍”，是印度佛教胜地之一。画家以精湛的艺术手法再现了佛门祇园大会的盛况，人物众多，线条劲健流畅。款“至正丙午岁佛生日，髪僧沐手敬写”。此卷绘于元至正丙午年（1366），时髪僧应寓居江浙一带。卷尾有明隆庆二年（1568）觉真上人的题跋。'
                },{
                    id:'unit3_04',
                    imgList:[
                        {imgurl:require('../static/imgs/proList3/big/proList3_03.jpg')}
                    ],
                    title:'《兰亭修禊图》轴',
                    etitle:'无款（明）',
                    size:'纵162.5厘米，横88厘米',
                    donor:'1986年钱自在先生捐赠',
                    quality:'绢本，设色',
                    text:'高远法构图，绘崇山峻岭，茂林修竹，曲水流觞之景。题材取自东晋王羲之《兰亭序》，是历代画家所喜爱的绘画题材，宋李公麟，明文徵明、唐寅等均有绘本。'
                },{
                    id:'unit3_05',
                    imgList:[
                        {imgurl:require('../static/imgs/proList3/big/proList3_05.jpg')}
                    ],
                    title:'白描《罗汉渡海图》卷',
                    etitle:'无款（明）',
                    size:'纵27厘米，横975厘米',
                    donor:'1986年钱自在先生捐赠',
                    quality:'纸本',
                    text:'以佛教故事中著名的罗汉渡海传说为题，画家用白描的技法描绘了十八罗汉渡海，海龙王携文武将相迎接的场面。笔法精湛纯熟，严谨中具有飘逸流畅。'
                },{
                    id:'unit3_06',
                    imgList:[
                        {imgurl:require('../static/imgs/proList3/big/proList3_06.jpg')}
                    ],
                    title:'行书七绝诗轴',
                    etitle:'于成龙（清）',
                    size:'纵165厘米，横43厘米',
                    donor:'1986年钱自在先生捐赠',
                    quality:'纸本',
                    text:'于成龙（1617—1684），字北溟，号于山，山西永宁（今吕梁离石）人。官至两江总督，以“天下廉吏第一”名垂青史。擅长诗词，亦工书法，用笔机巧独运，平中寓奇，法度谨严，笔法以晋人为主，极具王书用笔特点，是清初庙堂书法的上乘之作。释文：芳馥合将兰并茂，横斜宁与李争华。藤床几度劳春梦，飞过孤山处士家。于成龙。钤印：于成龙印（白）、西河（朱）、安思堂（朱）。'
                },{
                    id:'unit3_07',
                    imgList:[
                        {imgurl:require('../static/imgs/proList3/big/proList3_07.jpg')}
                    ],
                    title:'楷书录王应麟《困学纪闻》句轴',
                    etitle:'钱沣（清）',
                    size:'纵57厘米，横22厘米',
                    donor:'1986年钱自在先生捐赠',
                    quality:'纸本',
                    text:'钱沣（1740—1795），字东注，一字约甫，号南园，云南昆明人。诗文苍郁劲厚，兼擅书画。书学颜真卿，晚年参以欧阳询、褚遂良法，行书参米芾笔意。释文：咎繇曰：“彰厥有常，吉哉！”周公曰：“庶常吉士。”召公曰：“吉人吉士。”帝王用人之法，一言以蔽之曰“吉”。舜所举曰“元”、曰“恺”，吉德之实也；所去曰“凶”，吉德之反也。议论相传，气脉相续。在春秋时谓之“善人”，西汉谓之“长者”。惟吉则仁，所谓元者善之长，为天地立心者也。约甫书课。钤印：丰印（白）。'
                },{
                    id:'unit3_08',
                    imgList:[
                        {imgurl:require('../static/imgs/proList3/big/proList3_08.jpg')}
                    ],
                    title:'《盆梅图》轴',
                    etitle:'伊秉绶（清）',
                    size:'纵53厘米，横32厘米',
                    donor:'1986年钱自在先生捐赠',
                    quality:'绢本，墨笔',
                    text:'伊秉绶（1754—1815），字祖似，号墨卿，晚号默庵，福建汀州人。工诗词、篆刻，擅长书画，尤精隶书。画山水、墨梅，不泥成法，有金石气。其绘画作品传世较少，极为珍贵。图绘盆栽梅树一株，用笔苍劲，虬干新枝，梅花朵朵，争妍斗奇。款“桂严先生仁兄二十年好友，今遇于扬州作此正之。嘉庆十二年四月朔，小弟汀州伊秉绶记”。钤“伊”“墨卿氏”两方印。右下角钤收藏印“梓溪刘氏家藏金石书画印”。'
                },{
                    id:'unit3_09',
                    imgList:[
                        {imgurl:require('../static/imgs/proList3/big/proList3_09.jpg')}
                    ],
                    title:'草书《千字文》册',
                    etitle:'傅山（清）',
                    size:'纵24.7厘米，横25.5厘米',
                    donor:'1993年赵正楷先生捐赠',
                    quality:'纸本',
                    text:'此为傅山晚年为好友戴廷栻（字枫仲）所书的一件草书作品。傅山在附记中提到，戴枫仲要书千字文，已有三四年之久，正适其腕枯臂痛、人老眼花之时。虽然如此，却点画精到，行笔流畅，纵横磅礴，气韵贯通。册后钤白文方印“傅山印”。'
                },{
                    id:'unit3_10',
                    imgList:[
                        {imgurl:require('../static/imgs/proList3/big/proList3_10.jpg')}
                    ],
                    title:'楷书《阿难吟》册',
                    etitle:'傅山（清）',
                    size:'纵22.5厘米，横12.5厘米',
                    donor:'1993年赵正楷先生捐赠',
                    quality:'纸本',
                    text:'八开半，笔划丰腴、宽博、浑厚，承袭颜真卿书风。末开钤白文方印“傅山之印”，册后有常赞春、赵戴文、常旭春、赵铁山、赵正楷五人题跋。1987年台湾山西文献社曾出版发行此册影印本。'
                },]
            }
        },
        mounted(){
            var code=this.$route.query.id,
                data = this.allData;
            for (var i=0;i<data.length;i++) {
                if(data[i].id == code){
                    this.currData = data[i]
                }
            };
            var mySwiper = new Swiper('.swiper-container',{
                zoom:true,
                zoom: {
                    toggle:true,
                },
                noSwiping: true,
                touchAngle:0,
                noSwipingSelector: 'swiper-slide',
                shortSwipes : false,
                longSwipes : false,
                observer:true,//修改swiper自己或子元素时，自动初始化swiper
                observeParents:true,//修改swiper的父元素时，自动初始化swiper
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                    hideOnClick: true
                },
                direction: 'horizontal',
                slidesPerView:1,
                on: {
                    navigationHide: function(){

                    },
                    navigationShow: function(){

                    },
                    init:function () {
                        var oSwiper = document.querySelector('.swiper-container');
                        oSwiper.classList.add('zoomOut');
                    },
                    zoomChange: function(scale, imageEl,slideEl){
                        var oSwiper = document.querySelector('.swiper-container');
                        oSwiper.classList.remove('zoomOut');
                    },
                    slideChangeTransitionStart: function(){
                        var oActive = document.querySelector('.swiper-slide-active');
                        var oImg = oActive.querySelector('img');
                        var imgW = oImg.offsetWidth;
                        var imgH = oImg.offsetHeight;
                        if(imgW>imgH){
                            oImg.setAttribute('style','max-width:none;')
                        }else {
                            oImg.setAttribute('style','max-height:none;')
                        }
                    },
                    slideChange: function(){

                    },
                    touchMove: function(event){
                        var oSwiper = document.querySelector('.swiper-container');
                        oSwiper.classList.remove('zoomOut');
                    }
                },
            })
            setTimeout(() => {
                var oActive = document.querySelector('.swiper-container');
            var oImg = oActive.querySelector('img');
            var imgW = oImg.offsetWidth;
            var imgH = oImg.offsetHeight;
            console.log(imgW,imgW,456);
            if(imgW>imgH){
                oImg.setAttribute('style','max-width:none;')
            }else {
                oImg.setAttribute('style','max-height:none;')
            }
        },100);
        }
    }
</script>
<style scoped>
    .swiper-container {
        width:100%;
        height:100%;
        position: absolute;
    }
    .goback{
        width: 1.63rem;
        height: 1.63rem;
        background:url(../static/imgs/goback.png);
        background-size: 100% 100%;
        position: fixed;
        right: .17rem;
        top:40%;
        margin-top: -.815rem;
        z-index:1;
    }
    .imgbox{
        width: 100%;
        height: 100%;
        overflow:scroll;
    }
    .imgbox img{
        max-width:100%;
        max-height:100%;
    }
    .botomText{
        width: 100%;
        position: absolute;
        margin:  0 auto;
        bottom: 0;
        left: 0;
        height:10.32rem;
        background: #ffffff;
        border-radius: .3rem .3rem 0 0;
        transition: .2s transform ease-in;
        transform: translateY(8.32rem);
        z-index:1;
    }
    .botomText.active{
        transform: translateY(0);
    }
    .botomText .title{
        color:#333;
        font-size: .34rem;
        line-height: 1;
        font-weight: bold;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        letter-spacing: .01rem;
        padding:.36rem .4rem .29rem;
        text-align: center;
    }
    .hidden{display:none;}
    .bottomBtn{
        height:1rem;position: relative;;
    }
    .bottomBtn:before{content:'';width:.8rem;height:.1rem; border-radius: .5rem;background:#b2a08b;position: absolute;left:50%;top:50%;margin:-.05rem 0 0 -.4rem;}
    .botomText .attr{
        color:#666;
        font-size: .26rem;
        letter-spacing: .005rem;
        text-align: center;
        line-height: .45rem;
        padding:0 .4rem;
    }
    .botomDetail{
        padding:0 .4rem 0;
        margin-top: .62rem;
        line-height: .43rem;
        color:#666;
        font-size: .26rem;
        height:6.2rem;
        overflow-y: auto;
    }
    .swiper-button-next, .swiper-container-rtl .swiper-button-prev {
        background-image: url(../static/imgs/right.png);
        right:0;
        width:.68rem;
        height:1.04rem;
        background-size: cover;
        left: auto;}
    .swiper-button-prev, .swiper-container-rtl .swiper-button-next {
        background-image: url(../static/imgs/left.png);
        left:0;
        width:.68rem;
        height:1.04rem;
        background-size: cover;
        right: auto;}
    .zoomOut .swiper-slide-active img{
        /* transform: scale(3)!important; */
    }
    .swiper-button-prev.swiper-button-disabled, .swiper-button-next.swiper-button-disabled {
        display: none;
        cursor: auto;
        pointer-events:none;
    }
    .swiper-button-hidden{ display : none; }
    .swiper-zoom-container{
        display: -webkit-box!important;
    }
    .imgbox{overflow: scroll;-webkit-overflow-scrolling : touch;width: 100%;height: 100%;overscroll-behavior:contain;}
    .swiper-zoom-container{display: -webkit-box!important;}
    .swiper-slide-zoomed .goback,.swiper-slide-zoomed .botomText{display:none;}
</style>